<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
				<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de autoevaluación">
					<div class="container-fluid">
						<div class="row" id="slide-1">
							<div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
								<div class="p-3 pl-lg-5">
									<h2 class="mt-5">Actividad de autoevaluación</h2>
									<h3>Análisis textual</h3>
									<h5>Tipo de actividad: cuestionario (selección múltiple)</h5>
									<h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
									<p>Caracterizar los aspectos generales de las teorías de la adquisición del lenguaje.</p>
									<h4 class="mt-3">¿Qué hacer?</h4>
                                    <p>Lea con atención los enunciados y seleccione la respuesta que considere correcta.</p>
                                </div>
							</div>
							<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-AE justify-content-center align-items-center"> 
								<div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
									<div class="row mb-xl-3 mb-lg-3 ml-xl-3 bg-white ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100 p-4">
                                        <div class="col-12 mb-4">
                                           <div class="row">
                                                 
                                          
                                               <div class="col-12 mb-3">
                                                   <b>1. Las diferentes teorías sobre la adquisición del lenguaje parten de motivaciones que pueden ser endógenas o exógenas para explicar esta adquisición. La teoría ambientalista parte del criterio:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'"  class="Radiobutton checkAE mr-2 checkAE_1 " id="checkAE_1_A" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>a) Endógeno, porque analiza los cambios de conducta dentro del individuo.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta1Pos' class="Radiobutton checkAE mr-2 checkAE_1" id="checkAE_1_B" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>b) Exógeno, porque asume el contexto y el condicionamiento operante como principios de la adquisición. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>2. La teoría nativista se distancia de las demás corrientes al explicar la adquisición del lenguaje, pues esta intenta explicar el desarrollo lingüístico desde una base:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                      <button v-b-popover.click.blur.html='respuesta2Pos' class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_A" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>a) Innatista: favorece los mecanismos biológicos con los cuales los seres humanos nacen.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                      <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_B" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>b) Naturalista: explica que al ser humano se le debe dejar desarrollar sin intervención externa.</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>3. ¿A qué tipo de planteamiento teórico pertenece el ciclo que explica el procedimiento por el cual los seres humanos logran hacer una decodificación efectiva de los fonemas para poder realizar la lectura de un texto?</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_A" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>a) Conductista</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta3Pos' class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_B" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>b) Procesamiento</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>4. Las teorías cognitivas del desarrollo han intentado dar respuesta a:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_A" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>a) El modo como los niños y las niñas desarrollan una ruta fonológica para decodificar el lenguaje.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta4Pos' class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_B" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>b) El modo como los niños y las niñas desarrollan la inteligencia para resolver problemas. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>5. La importancia de conocer las teorías de adquisición del lenguaje en el marco de la formación en interpretación y traducción de la LSC radica en:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta5Pos' class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_A" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>a) Comprender y explicar desde la ciencia el funcionamiento de las lenguas naturales y la importancia de los procesos lingüísticos.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                      <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_B" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>b) Describir la praxis lingüística desde la práctica cultural.</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                            <button class="btn BtnPrincipal d-flex mx-auto mt-4 mb-4" @click="recargarPagina">Intentar nuevamente</button>
                                        </div>
									</div> 
                                      <p class="RefimgActiv">Foto por Lucrezia Carnelos en <a href="https://www.pexels.com/es-es/foto/mujer-lapiz-mono-colegio-4173106/" target='_blank' class="text-white">Unsplash</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
        </div>
    </div>
</template>

<script>
import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'AutoEvaluacion',
    data(){
      return{
        respuesta1Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">El fundamento de las teorías ambientalistas radica en describir y explicar los procesos de aprendizaje del lenguaje en el curso de la exterioridad.</p>',
        respuesta2Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">El nativismo sostiene una posición instintiva del lenguaje, donde se concede un valor fundamental al componente innato, a la idea de que los seres humanos vienen con unos mecanismos a priori que facilitan el conocimiento del lenguaje en los niños y niñas al nacer.</p>',
        respuesta3Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Un principio es reconocer el lenguaje como un sistema con criterio de comunicación que se da a través de un canal audio-vocal que permite la construcción del mensaje. Este sistema consta de una estructura organizada por categorías o niveles de la lengua, organizados de modo tal que permiten la diferenciación con otras especies como los animales.</p>',
        respuesta4Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">A diferencia de las demás perspectivas lingüísticas, los trabajos de la psicología cognitiva se han enfocado en los estudios sobre la inteligencia, la relación entre pensamiento y lenguaje y las etapas del desarrollo, el juego, la acción simbólica, entre otros.</p>',
        respuesta5Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Abordar desde la ciencia el funcionamiento de las lenguas permite comprender y explicar los fenómenos del lenguaje.</p>',
        popovers:[false,false,false,false,false]
      }
    },
    methods: {
    activar: function(event,numPregunta){
   
      let elementosGrupo=document.querySelectorAll(".checkAE_"+numPregunta);
     
      elementosGrupo.forEach(element => {
          element.classList.remove("active","i-check");
      });

     event.target.classList.add("active","i-check");

    
    //    elementosGrupo.forEach(element => {
    //     element.style.pointerEvents='none';
    //    });

    },

    recargarPagina: function(){
        location.reload();
    }
  },
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title // Cambiar el título de la página
    }
}
</script>